import { createSlice, Slice } from '@reduxjs/toolkit'
import { BackOfficeDataServiceAPI } from '@API/data-services/back-office-data-service'
import { GambytUser, Org } from '@Components/users/types'
import { setAuthOrg } from '../../config'
import { CustomerConfigResponse, FeatureFlag } from '@Generated/back-office-client/src'

export type UserState = {
  currentUser: GambytUser | null
  activeCustomerId: string | null
  activeCustomerMetadata: CustomerConfigResponse | null
}

export const initialUserState: UserState = {
  currentUser: null,
  activeCustomerId: null,
  activeCustomerMetadata: null,
}

export const userSlice: Slice<UserState> = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    setCurrentUser(state, action: { payload: GambytUser }) {
      state.currentUser = {
        ...action.payload,
        isGambytAdmin: state.currentUser?.isGambytAdmin ?? false,
        scopes: state.currentUser?.scopes ?? [],
        enabledFeatures: state.currentUser?.enabledFeatures ?? [],
      }
    },
    setActiveCustomer(state, action: { payload: { customer: Org; switchingCustomers?: boolean } }) {
      state.activeCustomerId = action.payload.customer.customerId
      setAuthOrg(action.payload.customer.id)
      BackOfficeDataServiceAPI.setCustomerForRequest(action.payload.customer.customerId)
    },
    setUserScopes(state, action) {
      if (state.currentUser) {
        state.currentUser.scopes = action.payload
      }
    },
    setEnabledFeatures(state, action: { payload: FeatureFlag[] }) {
      if (state.currentUser) {
        state.currentUser.enabledFeatures = action.payload
      }
    },
    setIsGambytAdmin(state, action: { payload: boolean }) {
      if (state.currentUser) {
        state.currentUser.isGambytAdmin = action.payload
      }
    },
    setUserMetadata(state, action) {
      if (state.currentUser) {
        state.currentUser.metadata = action.payload
      }
    },
    setCustomerMetadata(state, action) {
      state.activeCustomerMetadata = action.payload
    },
  },
})

export const UserActions = {
  ...userSlice.actions,
}

export const UserReducer = userSlice.reducer
